/**
 * Keep native form events instance-scoped instead of also submitting through
 * document listeners. Callers read values from the widget, not event detail.
 */
export function bindGenericFormSubmit(
  instance: HTMLElement,
  onSubmit: (event: CustomEvent<unknown>, instance: HTMLElement) => void,
  onChange?: (event: Event, instance: HTMLElement) => void
): () => void {
  const capture = (event: Event) => {
    if (!event.composedPath().includes(instance)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (instance.isConnected) onSubmit(event as CustomEvent<unknown>, instance);
  };
  instance.addEventListener('form-submitted', capture, true);
  const changed = (event: Event) => {
    if (instance.isConnected) onChange?.(event, instance);
  };
  const events = ['input', 'change', 'focusout'];
  if (onChange) events.forEach(event => instance.addEventListener(event, changed));
  return () => {
    instance.removeEventListener('form-submitted', capture, true);
    events.forEach(event => instance.removeEventListener(event, changed));
  };
}
